export default __webpack_public_path__ + "static/media/chicago.2d9e89c2.jpg";